import { render, staticRenderFns } from "./RestaurantReservationRow.vue?vue&type=template&id=dc157a02&scoped=true&"
import script from "./RestaurantReservationRow.vue?vue&type=script&lang=js&"
export * from "./RestaurantReservationRow.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantReservationRow.vue?vue&type=style&index=0&id=dc157a02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc157a02",
  null
  
)

export default component.exports